import { render, staticRenderFns } from "./TermsConditionsPage.vue?vue&type=template&id=1c02eb22&scoped=true"
import script from "./TermsConditionsPage.vue?vue&type=script&lang=js"
export * from "./TermsConditionsPage.vue?vue&type=script&lang=js"
import style0 from "./TermsConditionsPage.css?vue&type=style&index=0&id=1c02eb22&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c02eb22",
  null
  
)

export default component.exports